export interface UnreadDotColors {
  Background: {
    Default: {
      default: string
    }
  }
}

export const unreadDotColors: UnreadDotColors = {
  Background: {
    Default: {
      default: 'brand.solid',
    },
  },
}
